import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
// import plan1 from "../assets/plan1.jpg";
// import plan2 from "../assets/plan2.jpg";
import PaymentFormModal from "./PaymentFormModal";
import "../style/plans.css";

export default function DatingPlans({ show, onClose, profile }) {
    const [selectedPlan, setSelectedPlan] = useState(null);

    if (!show) return null;

    const plans = [
        {
            name: "Spark Plan",
            price: "$6.99 / month",
            desc1: "Boost your profile visibility and get daily smart matches.",
            desc2: "Perfect for new members looking to meet compatible matches quickly.",
        },
        {
            name: "Flame Plan",
            price: "$19.99 / month",
            desc1: "Enjoy unlimited rewinds, boosts, and compatibility insights.",
            desc2: "Best for people seeking deeper connections and more exposure.",
        },
    ];

    return (
        <>
            {/* Plans Modal */}
            {!selectedPlan && (
                <div
                    className="modal fade show"
                    style={{ display: "block", backgroundColor: "rgba(0,0,0,0.6)", zIndex: 1050 }}
                >
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content rounded-4 border-0 shadow">
                            <div className="modal-header border-0">
                                <h5 className="modal-title">
                                    Choose a Plan for <strong>{profile?.name}</strong>
                                </h5>
                                <button type="button" className="btn-close" onClick={onClose}></button>
                            </div>

                            <div className="modal-body">
                                <div className="row g-4">
                                    {plans?.map((plan) => (
                                        <div key={plan.name} className="col-md-6">
                                            <div className="card h-100 shadow-sm border-1 text-center">
                                                <div className="card-body">
                                                    <h5 className="fw-bold">{plan.name}</h5>
                                                    <p className="text-muted small mb-1">{plan.desc1}</p>
                                                    <p className="text-muted small mb-3">{plan.desc2}</p>
                                                    <h6 className="fw-semibold text-danger mb-3">{plan.price}</h6>
                                                    <button
                                                        className="btn bg-pink text-light w-100"
                                                        onClick={() => setSelectedPlan(plan)}
                                                    >
                                                        Select {plan.name}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="modal-footer border-0">
                                <button className="btn btn-secondary" onClick={onClose}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Payment Modal (opens when plan selected) */}
            {selectedPlan && (
                <PaymentFormModal
                    show={!!selectedPlan}
                    onClose={() => setSelectedPlan(null)}
                    plan={selectedPlan}
                    profile={profile}
                />
            )}
        </>
    );
}
